<template>
  <gp-tooltip :visible="!!element">
    <template v-if="element">
      {{ element.displayName }}
    </template>
  </gp-tooltip>
</template>

<script>
import Element from '../../../../classes/models/Element'
import GpTooltip from '../../../../../vue/common/Tooltip/Tooltip.vue'

export default {
  name: 'GpaElementTooltip',
  components: { GpTooltip },
  props: {
    element: { required: false, type: Element, default: null },
  },
}
</script>
